import { apiService } from './api';

export interface Notification {
  id: string;
  userId: string;
  type: string;
  title: string;
  message: string;
  depositId?: string;
  isRead: boolean;
  createdAt: string;
  deposit?: {
    id: string;
    amount: number;
    description: string;
    depositDate: string;
  };
}

class NotificationService {
  async getNotifications(): Promise<Notification[]> {
    const response = await apiService.get<Notification[]>('/notifications');
    return response.data.data;
  }

  async getUnreadCount(): Promise<number> {
    const response = await apiService.get<{ count: number }>('/notifications/unread-count');
    return response.data.data.count;
  }

  async markRead(id: string): Promise<void> {
    await apiService.patch(`/notifications/${id}/read`);
  }

  async markAllRead(): Promise<void> {
    await apiService.post('/notifications/mark-all-read');
  }

  async deleteNotification(id: string): Promise<void> {
    await apiService.delete(`/notifications/${id}`);
  }
}

export const notificationService = new NotificationService();
